export const environment = {
    production: false,
    urls: {
        api: 'https://api.n2g-iona-staging.net/v2/',
        auth: 'https://iona-test-staging.wla-backend.de/auth'
    }
};


